import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import {
  authCardSx,
  authLogoSx,
  authPageSx,
  authSubtitleSx,
  authTitleSx,
} from './authFormStyles';

interface AuthPageShellProps {
  title: string;
  subtitle?: string;
  maxWidth?: number;
  children: React.ReactNode;
}

export const AuthPageShell: React.FC<AuthPageShellProps> = ({
  title,
  subtitle,
  maxWidth = 420,
  children,
}) => {
  return (
    <Box sx={authPageSx}>
      <Paper elevation={0} sx={{ ...authCardSx, maxWidth }}>
        <Box
          component="img"
          src="/cw-red-logo.svg"
          alt="Canadawale Yar"
          sx={authLogoSx}
        />
        <Typography variant="h5" sx={authTitleSx}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={authSubtitleSx}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Paper>
    </Box>
  );
};
